import { render } from "./BtnLoginGoogle.vue?vue&type=template&id=cf5cfcd4&scoped=true"
import script from "./BtnLoginGoogle.vue?vue&type=script&lang=js"
export * from "./BtnLoginGoogle.vue?vue&type=script&lang=js"

import "./BtnLoginGoogle.vue?vue&type=style&index=0&id=cf5cfcd4&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf5cfcd4"]])

export default __exports__